// extracted by mini-css-extract-plugin
export var divider = "_kv-0";
export var systemMessage = "_kv-1";
export var systemMessageWrapper = "_kv-2";